import { useTranslation } from 'react-i18next';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  const renderList = (key) => {
    const items = t(key).split(';');
    return (
      <ul className="list-disc list-inside space-y-1.5 text-slate-600 ml-2">
        {items.map((item, i) => (
          <li key={i}>{item.trim()}</li>
        ))}
      </ul>
    );
  };

  const sections = [
    { title: 'privacy.section1Title', text: 'privacy.section1Text', list: 'privacy.section1Items' },
    { title: 'privacy.section2Title', text: 'privacy.section2Text', list: 'privacy.section2Items' },
    { title: 'privacy.section3Title', text: 'privacy.section3Text', list: 'privacy.section3Items', extra: 'privacy.section3Extra' },
    { title: 'privacy.section4Title', text: 'privacy.section4Text', list: 'privacy.section4Items' },
    { title: 'privacy.section5Title', text: 'privacy.section5Text' },
    { title: 'privacy.section6Title', text: 'privacy.section6Text', list: 'privacy.section6Items' },
    { title: 'privacy.section7Title', text: 'privacy.section7Text', contact: 'privacy.section7Contact' },
    { title: 'privacy.section8Title', text: 'privacy.section8Text' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title={`${t('privacy.title')} | Entrepôt Auto Montréal`}
        description={t('privacy.intro')}
      />
      <Navbar />

      {/* Hero */}
      <div className="bg-slate-900 pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-6 text-sm">
            <ArrowLeft className="h-4 w-4" />
            {t('sell.backHome')}
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center">
              <Shield className="h-6 w-6 text-blue-400" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('privacy.title')}
            </h1>
          </div>
          <p className="text-slate-400 text-sm">
            {t('privacy.lastUpdated')}: 12 mars 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Intro */}
        <p className="text-slate-700 text-lg leading-relaxed mb-10 pb-10 border-b border-slate-200">
          {t('privacy.intro')}
        </p>

        {/* Sections */}
        <div className="space-y-10">
          {sections.map((section, idx) => (
            <div key={idx}>
              <h2 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {t(section.title)}
              </h2>
              <p className="text-slate-600 mb-3 leading-relaxed">{t(section.text)}</p>
              {section.list && renderList(section.list)}
              {section.extra && (
                <p className="text-slate-600 mt-3 leading-relaxed italic">{t(section.extra)}</p>
              )}
              {section.contact && (
                <div className="mt-3 bg-slate-50 rounded-xl p-4 border border-slate-100">
                  {t(section.contact).split(';').map((line, i) => (
                    <p key={i} className="text-slate-700 text-sm">{line.trim()}</p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
